/*
The Map component used by the title page in the PDF Document
 */
import _ from 'lodash';
import printCfg from '@/services/print/pdfStyle.config';

const { colours } = printCfg.styles;
const { width, height } = printCfg;

const mapOverlay = ({ colour }) => {
    const svgMapOverlay = d3.create('svg');
    const fill = _.get(colours, colour) || 'black';
    const w = 640;
    svgMapOverlay.attr('viewBox', `0 0 ${w} ${w}`);
    const c = 140;
    const margin = (width > height ? width : height) || 100;
    const circPath = `M${w / 2} ${w}
                       C${c} ${w} 0 ${w - c} 0 ${w / 2}
                       C0 ${c} ${c} 0 ${w / 2} 0
                       C${w - c} 0 ${w} ${c} ${w} ${w / 2}`;
    svgMapOverlay.append('clipPath')
        .attr('id', 'overlay-clip')
        .append('path')
        .attr('d', `${circPath}
                     L${w} ${w + margin}
                     L${w + margin} ${w + margin}
                     L${w + margin} ${0 - margin}
                     L${0 - margin} ${0 - margin}
                     L${0 - margin} ${w + margin}
                     L${w} ${w + margin}
                     L${w} ${w} Z`);
    svgMapOverlay.append('rect')
        .attr('x', -margin)
        .attr('y', -margin)
        .attr('width', w + margin * 2)
        .attr('height', w + margin * 2)
        .attr('clip-path', 'url(#overlay-clip)')
        .attr('fill', fill)
        .attr('stroke', 'none');
    for (let i = 0; i < 5; i++) {
        const offset = i * 12;
        svgMapOverlay.append('circle')
            .attr('cx', w / 2 - offset)
            .attr('cy', w / 2 - offset)
            .attr('r', w / 2)
            .attr('clip-path', 'url(#overlay-clip)')
            .attr('fill', 'none')
            .attr('stroke', 'white');
    }
    const svg = svgMapOverlay.node();
    return svg;
};

export default ({ mapSrc, x = 'margin', y = 210, w = 420, colour = 'print.primary.7' }) => ({
    position: 'content',
    x,
    y,
    w,
    h: w,
    src: mapSrc,
    overlay: {
        position: 'parent',
        svg: mapOverlay({ colour })
    }
});
